module.exports = __webpack_public_path__ + "img/carousel-harrys.png?a7ae3969f972204ab81da8680d9dc782";